export default __webpack_public_path__ + "static/media/greentick-icon.32c8261a.svg";